import { useTranslation } from 'next-i18next/pages';
import Image from 'next/image';

import ContainerSection from '@pflegia/ui/shared/container-section';
import SimpleCard from '@pflegia/ui/shared/simple-card';

import PflegiaHeadline from '@domains/landing-page/components/headline/Headline';

const TRANSLATION_PREFIX = 'jobsPageHub.whyPflegia';

const REASONS = [
  { key: 'verifiedJobs', icon: '/assets/advantages/variety.svg' },
  { key: 'directApplication', icon: '/assets/advantages/fast-easy.svg' },
  { key: 'nearbyFirst', icon: '/assets/care-types/nursingHome.svg' },
  { key: 'salaryUpfront', icon: '/assets/advantages/free.svg' },
];

const WhyPflegia: React.FC = () => {
  const { t } = useTranslation('jobBoard', { keyPrefix: TRANSLATION_PREFIX });

  return (
    <ContainerSection className='my-32 flex flex-col items-center hyphens-auto'>
      <PflegiaHeadline
        arrowPosition='right'
        i18nKey={`jobBoard:${TRANSLATION_PREFIX}.title`}
        showArrow
        subTitle={`jobBoard:${TRANSLATION_PREFIX}.subtitle`}
      />

      <div className='grid auto-rows-fr gap-6 md:grid-cols-2'>
        {REASONS.map(({ key, icon }) => (
          <SimpleCard className='flex flex-col items-start gap-4 p-6 md:flex-row' key={key}>
            <Image alt='' className='my-auto shrink-0' height={90} src={icon} width={90} />
            <div>
              <h3 className='text-default mb-2 text-xl font-medium md:text-2xl'>{t(`reasons.${key}.title`)}</h3>
              <p className='text-secondary'>{t(`reasons.${key}.description`)}</p>
            </div>
          </SimpleCard>
        ))}
      </div>
    </ContainerSection>
  );
};

export default WhyPflegia;
